<fieldset >
    <legend>
        {{campo}}<span *ngIf="ehObrigatorio" class="campo-obrigatorio-mark" [matTooltip]="'telaPadrao.obrigatorio' | translate">*</span>
    </legend>
    <span class="tipo-campo">
        {{tipoDadoDescricao}} 
        <mat-icon class="add-value clickable" color="primary" [matTooltip]="'telaPadrao.addValorRandomico' | translate" (click)="addValorPadrao()"> 
            note_add
        </mat-icon>
        <div class="required" [matTooltip]="'telaPadrao.obrigatorio' | translate" *ngIf="ehObrigatorio">
        </div>
    </span>

    <div class="datepicker-wrapper filter-input" *ngIf="campoEhData()">
        <mat-form-field class="datepicker-field" appearance="outline">
            <input matInput [(ngModel)]="valor" [matDatepicker]="item" (dateChange)="dadoAlterado()">
            <mat-datepicker-toggle matSuffix [for]="item"></mat-datepicker-toggle>
            <mat-datepicker #item></mat-datepicker>
        </mat-form-field>
    </div>

    <mat-radio-group [(ngModel)]="valor" *ngIf="campoEhBoolean()" (change)="dadoAlterado()">
        <mat-radio-button id="{{campo+'_true'}}" [value]="true">
            {{ 'telaPadrao.sim' | translate }}
        </mat-radio-button>
        <mat-radio-button id="{{campo+'_false'}}" [value]="false">
            {{ 'telaPadrao.nao' | translate }}
        </mat-radio-button>
    </mat-radio-group>

    <input type="text" [(ngModel)]="valor" (ngModelChange)="dadoAlterado()"
        *ngIf="!campoEhNumerico() && !campoEhDecimal() && !campoEhData() && !campoEhBoolean()" class="form-control">

    <input type="number" [(ngModel)]="valor" (ngModelChange)="dadoAlterado()" *ngIf="campoEhNumerico()"
        class="form-control">

    <input type="number" [(ngModel)]="valor" (ngModelChange)="dadoAlterado()" step="0.0001" *ngIf="campoEhDecimal()"
        class="form-control">
</fieldset>